import { useContext } from 'react';
import { ConfigContext } from '@/context';
import { ComplianceRequestCreate } from './ComplianceRequestCreate';

type Props = {
  onCancel: () => void;
  onSubmit: () => void;
};

export function ComplianceRequestDelete({ onCancel, onSubmit }: Props) {
  const {
    deleteRequestName,
    deleteRequestDescription,
    privacyRequestsRequestsText,
    privacyRequestsRequestsWarning,
  } = useContext(ConfigContext);

  return (
    <ComplianceRequestCreate
      description={
        <>
          {/* <Text as="span" color="danger" fontWeight="bold"> */}
          <span className="font-bold text-red-600">
            {privacyRequestsRequestsWarning}:
          </span>{' '}
          {deleteRequestDescription}
        </>
      }
      placeholder={privacyRequestsRequestsText}
      requestType="delete"
      title={deleteRequestName}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
}
